import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import {
  selectAseIsEditable,
  selectAseIsOnline,
} from 'store/assessments/selectors';

import { QuestionDisplay } from './PagesMain/QuestionDisplay';
import { QuestionEdit } from './PagesMain/QuestionEdit';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ASSESSMENT],
  Screens.ASE_QUESTION
>;

export const QuestionScreen: React.FC<Props> = ({ navigation, route }) => {
  const isEditable = useSelector(selectAseIsEditable);
  const isOnline = useSelector(selectAseIsOnline);
  if (isEditable && !isOnline) {
    return <QuestionEdit navigation={navigation} route={route} />;
  }
  return <QuestionDisplay navigation={navigation} route={route} />;
};

type PropsR = NativeStackScreenProps<
  NavigationStacks[Stacks.ASEREPEATABLE],
  Screens.ASEREPEATABLE_QUESTION
>;

export const QuestionRepeatableScreen: React.FC<PropsR> = ({
  navigation,
  route,
}) => {
  const isEditable = useSelector(selectAseIsEditable);
  const isOnline = useSelector(selectAseIsOnline);
  if (isEditable && !isOnline) {
    return <QuestionEdit navigation={navigation} route={route} />;
  }
  return <QuestionDisplay navigation={navigation} route={route} />;
};
